import { useMemo } from 'react'
import { useTechSheetForPdfQuery } from 'api/hooks'

// если в currentLngProductData есть wine.techSheets (массив) — это CapturedWine или публичная страница,
// данные берём из него без запроса на бэкенд
const hasTechSheetsArray = currentLngProductData =>
  Array.isArray(currentLngProductData?.wine?.techSheets)

export const useLocalizedTechSheet = (
  productId,
  localeId,
  currentLngProductData
) => {
  const isStatic = hasTechSheetsArray(currentLngProductData)

  const currentLocaleId = currentLngProductData?.wine?.techSheet?.locale?.id

  const { data, loading } = useTechSheetForPdfQuery({
    variables: { productId, localeId },
    skip: isStatic || !productId || !localeId || localeId === currentLocaleId,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
  })

  const techSheetData = useMemo(() => {
    if (isStatic) {
      if (!localeId) return null
      const rawTechSheet =
        currentLngProductData.wine.techSheets.find(
          ts => ts.locale?.id === localeId
        ) ?? null
      // awards адаптированы на уровне страницы и лежат в techSheet[0];
      // переносим их в выбранный techSheet чтобы TechListPrint их показал
      const awards = currentLngProductData.wine.techSheet?.awards ?? []
      const techSheet = rawTechSheet ? { ...rawTechSheet, awards } : null
      return {
        ...currentLngProductData,
        wine: { ...currentLngProductData.wine, techSheet },
      }
    }

    const currentLocaleId = currentLngProductData?.wine?.techSheet?.locale?.id

    if (localeId === currentLocaleId) {
      return currentLngProductData
    }

    if (data && !loading) {
      return data?.product
    }

    return null
  }, [data, loading, localeId, currentLngProductData, isStatic])

  return { data: techSheetData, loading: isStatic ? false : loading }
}
